export const ITEM_WRAPPER_BOX = 'item-wrapper-box';
export const RED = 'red';
export const GREEN = 'green';